export const validateCardExpiry = (mm: string, yyyy: string) =>
  window.Stripe ? window.Stripe.card.validateExpiry(mm, yyyy) : false;

// as a hot-fix, luhnCheck and customValidateCardNumber were copied from stripe source code
const luhnCheck = function (a: string) {
  let b;
  let c;
  let d;
  let e;
  let f;
  let g;

  for (
    d = !0, e = 0, c = `${a}`.split('').reverse(), f = 0, g = c.length;
    f < g;
    // eslint-disable-next-line no-plusplus
    f++
  )
    // eslint-disable-next-line no-unused-expressions, no-sequences
    (b = c[f]),
      (b = parseInt(b as string, 10)),
      (d = !d) && (b *= 2),
      b > 9 && (b -= 9),
      (e += b);
  return e % 10 === 0;
};
const customValidateCardNumber = (card: string) => {
  // eslint-disable-next-line no-return-assign
  return (
    // eslint-disable-next-line no-param-reassign
    (card = `${card}`.replace(/\s+|-/g, '')),
    card.length >= 10 && card.length <= 16 && luhnCheck(card)
  );
};

export const validateCardNumber = (card: string) =>
  window.Stripe
    ? window.Stripe.card.validateCardNumber(card)
    : customValidateCardNumber(card);

export const validateCVC = (cvc: string) =>
  window.Stripe ? window.Stripe.card.validateCVC(cvc) : false;
export const getCreditCardIssuer = (card: string) =>
  window.Stripe ? window.Stripe.cardType(card) : '';
